const ONE_INCH_IN_MMS = 25.4;

export function pixelsToMms(pixels: number, dpi = 300, roundMethod = (v) => v) {
  return roundMethod((pixels / dpi) * ONE_INCH_IN_MMS);
}

export function mmsToPixels(mms: number, dpi = 300, roundMethod = (v) => v) {
  return roundMethod((mms / ONE_INCH_IN_MMS) * dpi);
}
